<style lang="stylus">
    .worklist-menu{
        margin 0 auto
        margin-top 48px
        max-width 100%
        width calc(100% - 204px)
        position relative
        @media screen and (max-width: 1280px)  {
    		margin-top: 42px;
    	}
        .titles {
    		font-weight: bold;
    		font-size: 36px;
            line-height: 36px;
    		text-align: center;
    		color: #000000;

    		.titles-color {
    			color: #017bff;
    		}
    		@media screen and (max-width: 768px) {
    			font-size: 20px;
    		}
    	}

    	.menu-group {
    		padding-top: 32px;
    		display: flex;
    		flex-wrap: wrap;
    		justify-content: center;
    		max-width: 975px;
    		width: 100%;
    		margin: 0 auto;
            @media screen and (max-width: 1280px)  {
                padding-top: 24px;
            }
            &.fr-menu-group{
                max-width: 1100px;
            }
    		.menu-item {
    			font-size: 16px;
    			height: 36px;
    			line-height: 36px;
    			padding: 0px 17.5px;
    			color: #000000;
    			border: 1px solid rgba(0, 0, 0, 0.2);
    			border-radius: 47px;
    			white-space: nowrap;
    			margin-right: 8px;
    			margin-bottom: 16px;
    			cursor: pointer;
    			transition: all 0.2s;
    			&.active {
    				background: #017fff;
    				border: 1px solid #017fff;
    				color: #fff !important;
    			}
    			&:hover {
    				border: 1px solid #017fff;
    				color: #017fff;
    			}
    		}
    		@media screen and (max-width: 768px) {
    			.menu-item {
    				margin-right: 4px;
    				margin-bottom: 10px;
    				font-size: 14px;
    				height: 28px;
    				line-height: 28px;
    				padding: 0px 10px;
    			}
    		}
    	}
    }
</style>

<template>
    <div class="worklist-menu">
        <div class="titles">
            {{ $t("titleBefore") }}
            <span class="titles-color">{{ $t("titleAfter") }}</span>
        </div>
        <div class="menu-group" ref="menuGroup">
            <div
                class="menu-item"
                v-for="item in editorTags"
                :key="item.lv1id"
                :class="{ active: activeMenu === item.lv1id }"
                @click="clickList(item.lv1id)"
            >
                {{ item.lv1name }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mountedDone: false,
                getTagCallback: [],
                done: false,
                tagsWatch: false,
            };
        },
        observer: null,
        watch: {
            lang() {
                let lang = this.isPC ? this.pcLang : this.lang;
                this.$store.dispatch("getTagClass", { lang });
            },
            editorTags() {
                if (this.tagsWatch) return;
                if (this.editorTags.length) {
                    this.tagsWatch = true;
                    const targetNode = this.$refs.menuGroup;
                    if (targetNode) {
                        this.observer = new IntersectionObserver((entires) => {
                            this.$store.commit("setState", {
                                type: "showSearch",
                                data: !entires[0].isIntersecting,
                            });
                        });
                        this.observer.observe(targetNode);
                    }
                }
            },
        },
        props: ["albumAction"],
        computed: {
            activeMenu: {
                get() {
                    return this.$store.state.activeMenu;
                },
                set(data) {
                    this.$store.commit("setState", {
                        type: "activeMenu",
                        data,
                    });
                },
            },
            editorTags() {
                return this.$store.state.tplCenter.editorTags;
            },
            pcLang() {
                return this.$store.state.pcLang;
            },
        },
        mounted() {
            //pc新建页点击更多
            if (this.isPC) {
                let setLocatTagStr = (data) => {
                    let pcInfo =
                        Object.prototype.toString.call(data) == "[object Object]"
                            ? data
                            : Object.prototype.toString.call(data) == "[object String]"
                              ? JSON.parse(data)
                              : null;
                    if (!pcInfo) return;
                    let str = pcInfo["NameU"] || pcInfo["Name"];
                    this.$store.commit("setState", {
                        type: "locatTagStr",
                        data: str,
                    });
                };
                let setKey = (data) => {
                    if (this.mountedDone) {
                        setLocatTagStr(data);
                        this.checkTag();
                    } else {
                        this.getTagCallback.push([setLocatTagStr, data]);
                    }
                };
                this.$bus.$on("setClassifyKey", setKey);
                this.$once("hook:beforeDestroy", () => {
                    this.$bus.$off("setClassifyKey", setKey);
                });
            }
            this.initTagClass();
            this.$bus.$on("setActiveMenu", this.setActive);
            this.$bus.$on("clickList", this.clickList);
            this.$bus.$on("storeToSymbol", this.toSymbol);
        },
        beforeDestroy() {
            this.$bus.$off("setActiveMenu");
            this.$bus.$off("clickList");
            this.$bus.$off("storeToSymbol");
            this.$store.commit("setState", {
                type: "showSearch",
                data: false,
            });
            this.cancelObserve();
        },

        methods: {
            cancelObserve() {
                if (this.observer) {
                    this.observer.unobserve(this.$refs.menuGroup);
                    this.observer = null;
                }
            },
            initTagClass() {
                // 重置workclass选中项
                this.activeMenu = null;
                let lang = this.isPC ? this.pcLang : this.lang;
                this.$store.dispatch("getTagClass", { lang }).then((e) => {
                    if (this.getTagCallback.length > 0) {
                        let item = this.getTagCallback.pop();
                        item[0](item[1]);
                    }
                    if (this.albumAction) {
                        this.toSymbol();
                    } else {
                        this.activeMenu = this.editorTags?.[0]?.lv1id;
                        this.checkTag();
                        this.mountedDone = true;
                    }
                });
            },
            checkTag() {
                this.$bus.$emit("clearSearch");
                if (this.isPC) {
                    this.$store.commit("setState", {
                        type: "templateSelect",
                        data: "index",
                    });
                }
                this.$nextTick(() => {
                    const str = this.$store.state.locatTagStr;
                    if (str) {
                        this.$store.commit("setState", {
                            type: "locatTagStr",
                            data: null,
                        });
                        this.$bus.$emit("setSearchKey", str);
                    } else {
                        this.updateFilter({
                            offset: 0,
                            classId: 0,
                            search: "",
                        });
                    }
                });
            },
            updateFilter(filterParams) {
                // 更新过滤条件并获取模板
                this.$emit("on-filter", filterParams);
            },
            clickList(lid) {
                let targetDom = document.querySelector(".store-box");
                targetDom.scrollTo(0, 0);
                this.activeMenu = lid;
                this.$bus.$emit("clearSearch");
                this.updateFilter({
                    offset: 0,
                    classId: lid,
                    search: "",
                });
            },
            setActive() {
                this.activeMenu = this.editorTags?.[0]?.lv1id;
            },
            toSymbol() {
                let classList = this.$store.state.tplCenter.editorTags;
                for (let item of classList) {
                    if (item.name_raw == "Symbol") {
                        this.clickList(item.lv1id);
                        break;
                    }
                }
            },
        },
    };
</script>
<i18n>
{
  "zh": {
    "titleBefore": "探索",
    "titleAfter": "所有图表模板"
  },
  "tw": {
    "titleBefore": "探索",
    "titleAfter": "所有圖表模板"
  },
  "en": {
    "titleBefore": "Explore",
    "titleAfter": "All Diagrams Templates"
  },
  "jp": {
    "titleBefore": "豊富なテンプレート群がここに",
    "titleAfter": " "
  },
  "fr": {
    "titleBefore": "Explorer",
    "titleAfter": "Tous les modèles de diagrammes"
  },
  "de": {
    "titleBefore": "Erkundung",
    "titleAfter": "Alle Diagrammvorlagen"
  },
  "es": {
    "titleBefore": "Explorar",
    "titleAfter": "Todas las Plantillas de Diagramas"
  },
  "pt": {
    "titleBefore": "Explorar",
    "titleAfter": "Todos os modelos de diagramas"
  },
  "it": {
    "titleBefore": "Esplora",
    "titleAfter": "Tutti i Modelli di Diagrammi"
  },
  "kr": {
    "titleBefore": "탐색하기",
    "titleAfter": "모든 템플릿"
  },
  "id": {
    "titleBefore": "Jelajahi",
    "titleAfter": "Semua Templat Diagram"
  }
}
</i18n>
